import React from "react";
import { Platform } from "react-native";
import { defineMessages, injectIntl } from "react-intl";
import styled from "styled-components/native";
import { material } from "react-native-typography";

const messages = defineMessages({
  noDataFound: {
    id: "noDataFound",
    defaultMessage: "No data was found."
  },

  loading: {
    id: "loading",
    defaultMessage: "Loading..."
  }
});

// Text style used to show the "No data was found" message
const NoDataText = styled.Text`
  ${material.titleObject}

  ${Platform.OS === "web" && "display: block;"}
  color: ${props => props.theme.fontColor};
  text-align: center;
  margin-top: 20px;
`;

// Styles and localizes the "No data was found" message
const NoRows = injectIntl(props => <NoDataText>{props.intl.formatMessage(messages.noDataFound)}</NoDataText>);

// Wrapper for the "Loading" row, which pads and styles it to look like a record row
const RowWrapper = styled.View`
  ${props => props.theme.listRowStyle}
`;

// Text style used to show the "Loading" message
const LoadingText = styled.Text`
  ${material.body1Object}

  color: ${props => props.theme.fontColor};
`;

// Default row renderer that either calls the recordRenderer when the data has been loaded or shows the "Loading" message
const defaultRowRenderer = (rowProps, rows) => {
  const { intl, recordRenderer, key, index, item, style } = rowProps;

  if (index < rows.length) {
    return recordRenderer(rowProps, item, rows);
  } else {
    return (
      <RowWrapper key={key} style={style}>
        <LoadingText>{intl.formatMessage(messages.loading)}</LoadingText>
      </RowWrapper>
    );
  }
};

export {
  messages,
  NoDataText,
  NoRows,
  RowWrapper,
  LoadingText,
  defaultRowRenderer
};
